
import Routes from '@/router/routes'
import env from '@/config/env'

const Parse = require('parse')
Parse.initialize(env.api.appId);
Parse.serverURL = env.api.baseUrl;

export default {
	name: 'contracts',
	data () {
		return {
			routes : Routes
		}
	},
	methods : {},
	components : {},
	created () {}
}


// WEBPACK FOOTER //
// ./src/components/private/history/script.js